import type { MicrophoneState } from "@limrun/ui";
import { useCallback,type ReactNode } from "react";

import { toast } from "@/components/ui/use-toast";
import { cn } from "@/lib/utils";

// useMicrophoneErrorToast returns the onMicrophoneStateChange handler shared
// by every live stream view: surface microphone failures as a toast.
export function useMicrophoneErrorToast() {
	return useCallback((state: MicrophoneState) => {
		if (!state.error) return;
		toast({
			title: "Microphone unavailable",
			description: state.error,
			variant: "destructive",
		});
	}, []);
}

// Session playback uses a bordered stream with an optional camera overlay.
export function LiveStreamBox({
	children,
	overlay,
	className,
}: {
	children: ReactNode;
	overlay?: ReactNode;
	className?: string;
}) {
	return (
		<div
			className={cn(
				"relative flex h-full items-center justify-center overflow-hidden rounded-lg bg-muted/30",
				className,
			)}
		>
			{children}
			{overlay && (
				<div className="pointer-events-auto absolute right-3 top-3 z-10">
					{overlay}
				</div>
			)}
		</div>
	);
}
